import React from "react";
import { RefreshCw, MessageCircle } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") console.error("UI error boundary", error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 text-center">
        <div className="eyebrow">Something went wrong</div>
        <h1 className="font-serif text-3xl sm:text-4xl mt-4" style={{ color: "var(--ink)" }}>This page hit a snag.</h1>
        <p className="mt-4 max-w-md mx-auto text-base" style={{ color: "var(--ink-soft)" }}>
          Your cart is safe. Reload to try again, or message us on WhatsApp and we'll complete your order by hand.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <button data-testid="error-boundary-reload" className="btn-brand justify-center" onClick={() => window.location.reload()}>
            <RefreshCw size={16} /> Reload page
          </button>
          <a href="https://wa.me/2347072260372" className="btn-outline justify-center" data-testid="error-boundary-whatsapp">
            <MessageCircle size={16} /> WhatsApp us
          </a>
        </div>
      </div>
    );
  }
}
